import Font22 from '@assets/icons/font-22.svg'
import { Icon } from './Icon'

export const Font22Icon = Icon(Font22)
